import { prefersReducedMotion } from '@/utils/motion'

/**
 * The landing sections the visitor top bar links to. The page scrolls inside the app shell's scroller, not the window,
 * so a plain #hash link never moves it: the bar and HomeView scroll the section into view themselves.
 */
export const LANDING_SECTIONS = [
  { id: 'examples', label: 'Examples' },
  { id: 'how-it-works', label: 'How it works' },
] as const

/** Scrolls a landing section under the floating bar (each section sets its own scroll margin). */
export function scrollToSection(id: string): boolean {
  const el = document.getElementById(id)
  if (!el) return false
  el.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' })
  return true
}
